const InputLabel = ({ children, htmlFor, textSize }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`block ${
        textSize ? textSize : "text-sm"
      } font-medium leading-6 text-ink-700`}
    >
      {children}
    </label>
  );
};

export default InputLabel;
